module.exports = __webpack_public_path__ + "db8f27b6531b7e43b042e7323a15f901.png";